// src/components/common/Footer.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { categories } from '../../data/categories';
import Icon from './Icon';

const officialSites = [
    { name: '복지로', url: 'https://www.bokjiro.go.kr' },
    { name: '정부24', url: 'https://www.gov.kr' },
    { name: '고용24', url: 'https://www.work24.go.kr' },
    { name: '국세청 홈택스', url: 'https://www.hometax.go.kr' },
    { name: '한국장학재단', url: 'https://www.kosaf.go.kr' },
];

const Footer: React.FC = () => (
    <footer className="gh-footer">
        <div className="wrap">
            <div className="gh-footer__top">
                <div className="gh-footer__brand">
                    <Link to="/" className="gh-logo">
                        <span className="gh-logo__mark">
                            <Icon name="shield" size={20} strokeWidth={1.9} />
                        </span>
                        <span className="gh-logo__text">
                            <span className="gh-logo__name">고브인포</span>
                            <span className="gh-logo__sub">정부지원금 정보센터</span>
                        </span>
                    </Link>
                    <p className="gh-footer__desc">
                        흩어져 있는 대한민국 정부지원금 정보를 한곳에 모아 정리합니다.
                        2026년 기준 자격요건·지원금액·신청방법과 2027년 정부 예산안 전망까지
                        쉽게 확인하세요.
                    </p>
                </div>

                <div>
                    <h3 className="gh-footer__coltitle">분야별 지원금</h3>
                    <div className="gh-footer__list">
                        {categories.slice(1).map(c => (
                            <Link key={c.id} to={c.path}>
                                {c.name}
                            </Link>
                        ))}
                    </div>
                </div>

                <div>
                    <h3 className="gh-footer__coltitle">연도별 정보</h3>
                    <div className="gh-footer__list">
                        <Link to="/2026">2026년 달라지는 정부지원금</Link>
                        <Link to="/2027">2027년 정부지원금 전망</Link>
                        <Link to="/">2026년 정부지원금 총정리</Link>
                        <Link to="/search">지원금 통합 검색</Link>
                    </div>
                </div>

                <div>
                    <h3 className="gh-footer__coltitle">공식 신청 사이트</h3>
                    <div className="gh-footer__list">
                        {officialSites.map(s => (
                            <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer">
                                {s.name}
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            <div className="gh-disclaimer">
                본 사이트는 공공기관이 아닌 민간 정보 제공 서비스입니다. 게시된 내용은 각 부처의 공고와
                보도자료를 바탕으로 정리한 것으로, 실제 신청 자격과 지급 금액은 개인의 소득·재산 및
                해당 기관의 최종 심사 결과에 따라 달라질 수 있습니다. 신청 전 반드시 소관 기관의
                공식 공고를 확인하시기 바랍니다.
            </div>

            <div className="gh-footer__bottom">
                <p className="gh-footer__copy">
                    &copy; {new Date().getFullYear()} 고브인포(GoveInfo). All rights reserved.
                </p>
                <nav className="gh-footer__policy" aria-label="약관">
                    <Link to="/privacy">개인정보처리방침</Link>
                    <Link to="/terms">이용약관</Link>
                    <Link to="/contact">문의하기</Link>
                </nav>
            </div>
        </div>
    </footer>
);

export default Footer;
